import { render, staticRenderFns } from "./cdetail.vue?vue&type=template&id=51ce77bd&"
import script from "./cdetail.vue?vue&type=script&lang=js&"
export * from "./cdetail.vue?vue&type=script&lang=js&"
import style0 from "./cdetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports